import { enUS as createPasswordEnUS } from './Locale/CreatePassword/enUS';
import { esES as createPasswordEsES } from './Locale/CreatePassword/esES';
import { ptBR as createPasswordPtBR } from './Locale/CreatePassword/ptBR';
import { enUS as forgotEnUS } from './Locale/ForgotPassword/enUS';
import { esES as forgotEsES } from './Locale/ForgotPassword/esES';
import { ptBR as forgotPtBR } from './Locale/ForgotPassword/ptBR';
import { enUS as loginEnUS } from './Locale/Login/enUS';
import { esES as loginEsES } from './Locale/Login/esES';
import { ptBR as loginPtBR } from './Locale/Login/ptBR';
import { enUS as signupEnUS } from './Locale/Signup/enUS';
import { esES as signupEsES } from './Locale/Signup/esES';
import { ptBR as signupPtBR } from './Locale/Signup/ptBR';
import { enUS as twoFactorEnUS } from './Locale/TwoFactor/enUS';
import { esES as twoFactorEsES } from './Locale/TwoFactor/esES';
import { ptBR as twoFactorPtBR } from './Locale/TwoFactor/ptBR';
import { env } from '@/env';
import type { IOnboardTemplate } from '@/Templates/Onboard/Types/OnboardTemplate.types';

const SonarOnboard: IOnboardTemplate = {
  logo: `${env.VITE_CDN_URL}/Sonarprint/logo/logo-color.svg`,
  logo_dark: `${env.VITE_CDN_URL}/Sonarprint/logo/logo-color.svg`,
  art_desktop: `${env.VITE_CDN_URL}/Sonarprint/login-art.webp`,
  art_desktop_dark: `${env.VITE_CDN_URL}/Sonarprint/login-art.webp`,
  art_mobile: `${env.VITE_CDN_URL}/Sonarprint/login-art.webp`,
  art_mobile_dark: `${env.VITE_CDN_URL}/Sonarprint/login-art.webp`,
  login: {
    locale: {
      ptBR: loginPtBR,
      enUS: loginEnUS,
      esES: loginEsES,
    },
  },
  forgotPassword: {
    locale: {
      ptBR: forgotPtBR,
      enUS: forgotEnUS,
      esES: forgotEsES,
    },
  },
  createPassword: {
    locale: {
      ptBR: createPasswordPtBR,
      enUS: createPasswordEnUS,
      esES: createPasswordEsES,
    },
  },
  signup: {
    locale: {
      ptBR: signupPtBR,
      enUS: signupEnUS,
      esES: signupEsES,
    },
  },
  twoFactor: {
    locale: {
      ptBR: twoFactorPtBR,
      enUS: twoFactorEnUS,
      esES: twoFactorEsES,
    },
  },
};

export { SonarOnboard };
